import { getPartnerResources } from '../repository/getPartnerResources'
import { useEffect, useState } from 'react'

export type PublisherArticleRSS = {
  type: string
  code: string
  hash: string
}

export const fetchData = async () => {
  const request = await getPartnerResources()
  return {
    type: request.data.type.charAt(0),
    code: request.data.attributes.code,
    hash: request.data.attributes.hashed_id
  }
}

export const usePublisherInfo = () => {
  const [publisher, setPublisher] = useState<PublisherArticleRSS | null>(null)
  const [status, setStatus] = useState<'loading' | 'error' | 'success'>()
  const [error, setError] = useState()

  useEffect(() => {
    if (status === undefined) {
      setStatus('loading')
      fetchData()
        .then((data) => {
          setPublisher(data)
          setStatus('success')
        })
        .catch((error) => {
          setStatus('error')
          setError(error)
        })
    }
  }, [status])

  return { status, publisher, error }
}
